<template>
  <div style="padding: 15px; max-width: 1550px" class="d-flex">
    <template>
      <div class="vehicle-block">
        <div style="height: 265px">
          <div class="card-header bg-navyblue">Vehicle Details</div>
          <div class="vehicle-details-block">
            <div class="vehicle-details-block-row d-flex">
              <div class="vehicle-details-block-row-left d-flex">
                <div class="d-flex vehicle-details-block-row-left_left">
                  <div class="vehicle-details-block-row-name">Rego</div>
                  <div class="vehicle-details-block-row-info">{{ vehicle?.rego }}</div>
                </div>
                <div class="d-flex vehicle-details-block-row-left_right">
                  <div class="vehicle-details-block-row-name">VIN</div>
                  <div class="vehicle-details-block-row-info">{{ vehicle?.VIN }}</div>
                </div>
              </div>
              <div class="vehicle-details-block-row-right d-flex">
                <div class="vehicle-details-block-row-name" style="width: 130px; margin-left: 5px">Market Value Mid
                </div>
                <div class="vehicle-details-block-row-info">{{ vehicle?.market_value?.middle_value|formatMoney }}</div>
              </div>
            </div>
            <div class="vehicle-details-block-row d-flex">
              <div class="vehicle-details-block-row-left d-flex">
                <div class="d-flex vehicle-details-block-row-left_left">
                  <div class="vehicle-details-block-row-name">Make</div>
                  <div class="vehicle-details-block-row-info">{{ vehicle?.make }}</div>
                </div>
                <div class="d-flex vehicle-details-block-row-left_right">
                  <div class="vehicle-details-block-row-name">Build Date</div>
                  <div class="vehicle-details-block-row-info">{{ vehicle?.build_date }}</div>
                </div>
              </div>
              <div class="vehicle-details-block-row-right d-flex">
                <div class="vehicle-details-block-row-name" style="width: 130px; margin-left: 5px">Market Value High
                </div>
                <div class="vehicle-details-block-row-info">{{ vehicle?.market_value?.high_value|formatMoney }}</div>
              </div>
            </div>
            <div class="d-flex" style="min-width: 850px;">
              <div style="width: 70%; margin-right: 5px">
                <div class="vehicle-details-block-row-plus d-flex">
                  <div class="vehicle-details-block-row-left d-flex">
                    <div class="d-flex vehicle-details-block-row-left_left">
                      <div class="vehicle-details-block-row-name">Model</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.model }}</div>
                    </div>
                    <div class="d-flex vehicle-details-block-row-left_right">
                      <div class="vehicle-details-block-row-name">Comp Date</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.compliance_date }}</div>
                    </div>
                  </div>
                </div>
                <div class="vehicle-details-block-row-plus d-flex">
                  <div class="vehicle-details-block-row-left d-flex">
                    <div class="d-flex vehicle-details-block-row-left_left">
                      <div class="vehicle-details-block-row-name">Series</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.series }}</div>
                    </div>
                    <div class="d-flex vehicle-details-block-row-left_right">
                      <div class="vehicle-details-block-row-name">Color</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.color }}</div>
                    </div>
                  </div>
                </div>
                <div class="vehicle-details-block-row-plus d-flex">
                  <div class="vehicle-details-block-row-left d-flex">
                    <div class="d-flex vehicle-details-block-row-left_left">
                      <div class="vehicle-details-block-row-name">Model Code</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.model_code }}</div>
                    </div>
                    <div class="d-flex vehicle-details-block-row-left_right">
                      <div class="vehicle-details-block-row-name">Paint Code</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle.paint_code }}</div>
                    </div>
                  </div>
                </div>
                <div class="vehicle-details-block-row-plus d-flex">
                  <div class="vehicle-details-block-row-left d-flex">
                    <div class="d-flex vehicle-details-block-row-left_left">
                      <div class="vehicle-details-block-row-name">Variant</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.variant }}</div>
                    </div>
                    <div class="d-flex vehicle-details-block-row-left_right">
                      <div class="vehicle-details-block-row-name">Odometer</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.odometer }}</div>
                    </div>
                  </div>
                </div>
                <div class="vehicle-details-block-row-plus d-flex">
                  <div class="vehicle-details-block-row-left d-flex">
                    <div class="d-flex vehicle-details-block-row-left_left">
                      <div class="vehicle-details-block-row-name">Transmission</div>
                      <div class="vehicle-details-block-row-info">{{ vehicle?.transmission }}</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="vehicle-details-block-left-info">
                {{ vehicle?.market_value?.value_reasoning }}
              </div>
            </div>
          </div>
        </div>
        <!-- <div>
          <div class="card-header bg-navyblue card-header-blue">Estimate Summary</div>
          <div class="vehicle-block-summary d-flex">
            <div class="vehicle-block-summary-item" style="background-color: #e3f5fb;">
              <div class="vehicle-block-summary-item-total-title">
                Confirmed Grand Total
              </div>
              <div class="vehicle-block-summary-item-total-sum">
                {{ damage?.quote_summary?.confirmed_grand_total | formatMoney }}
              </div>
            </div>
            <div class="vehicle-block-summary-item">
              <div class="vehicle-block-summary-item-category d-flex">
                <div class="vehicle-block-summary-item-category-name">
                  R&R
                </div>
                <div class="vehicle-block-summary-item-category-sum">
                  {{ damage?.quote_summary?.total_remove_and_replace_cost | formatMoney }}
                </div>
              </div>
              <div class="vehicle-block-summary-item-category d-flex">
                <div class="vehicle-block-summary-item-category-name">
                  Repair
                </div>
                <div class="vehicle-block-summary-item-category-sum">
                  {{ damage?.quote_summary?.total_repair_cost | formatMoney }}
                </div>
              </div>
              <div class="vehicle-block-summary-item-category d-flex">
                <div class="vehicle-block-summary-item-category-name">
                  Paint
                </div>
                <div class="vehicle-block-summary-item-category-sum">
                  {{ damage?.quote_summary?.total_paint_cost | formatMoney }}
                </div>
              </div>
              <div class="vehicle-block-summary-item-category d-flex">
                <div class="vehicle-block-summary-item-category-name">
                  Parts
                </div>
                <div class="vehicle-block-summary-item-category-sum">
                  {{ damage?.quote_summary?.total_confirmed_parts_cost | formatMoney }}
                </div>
              </div>
              <div class="vehicle-block-summary-item-category d-flex">
                <div class="vehicle-block-summary-item-category-name">
                  Other
                </div>
                <div class="vehicle-block-summary-item-category-sum">
                  {{ damage?.quote_summary?.total_miscellaneous_cost | formatMoney }}
                </div>
              </div>
            </div>
            <div class="vehicle-block-summary-item" style="border-color: #f9be2d; background-color: #fdf7c2">
              <div class="vehicle-block-summary-item-total-title" style="color: #826204">
                Potential Provisional Total
              </div>
              <div class="vehicle-block-summary-item-total-sum" style="color: #f9be2d;">
                {{damage?.quote_summary?.potential_provisional_cost_total | formatMoney}}
              </div>
            </div>
          </div>
          <div class="vehicle-block-summary-notes">
            <span style="font-weight: 800">Note: </span>{{ damage?.quote_summary?.provisional_items_note }}
          </div>
        </div> -->
        <div style="margin-bottom: 30px">
          <div class="card-header bg-navyblue card-header-blue">Parts Assessment</div>
          <div class="vehicle-block-table" ref="vehicleTable" v-for="(area,index) in damage?.assessment" :key="'area-' + index">
            <h3 v-if='area.parts?.length != 0' style="padding: 10px 0; font-size: 18px;">Damage Area: {{ area.area }}</h3>
            <div v-if='area.parts?.length != 0' class="vehicle-block-table-header">
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-status"
                   style="padding-left: 15px">
                Status
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-name">
                Part Name
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-action">
                Action
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-qty">
                Qty
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-cost">
                Est Cost
              </div>
              <div class="vehicle-block-table-header-item" style="width: 60px; text-align: center">
                <div>On Report</div>
                <div class="damage-form-table-header-item-on-report-icon">R</div>
              </div>
              <div class="vehicle-block-table-header-item" style="width: 60px; text-align: center">
                <div>Add Est</div>
                <label style="margin-left: 7.5px; margin-top: 5px" class="form-check-inline checkbox">
                  <input class="form-check-input" name="hide-series-checkbox" type="checkbox"
                         v-model="area.allCheckedEst"
                         :disabled="damage?.isDAEstimateCreated"
                         @change="(val)=>changeAllCheckEst(val,area)"/>
                  <span class="icon"><i class="bx bx-check"></i></span>
                </label>
              </div>
            </div>
            <div class="vehicle-block-table-body d-flex" v-for="(part,index1) in area?.parts" :key="'part-' + index + '-' + index1">
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-status">
                <div :class="{
                    'confirmed-status': part.assessment_status === 'CONFIRMED_VISIBLE',
                    'provisional-status': part.assessment_status !== 'CONFIRMED_VISIBLE'
                  }">
                  {{ part.assessment_status === 'CONFIRMED_VISIBLE' ? 'Confirmed' : 'Provisional' }}
                </div>
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-name">
                <div style="text-transform: uppercase; font-weight: 700">{{ part.name }}</div>
                <div style="font-style: italic">{{ part.notes }} {{ part?.notes ? `(Image: ${part.image_name})` : '' }}
                </div>
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-action"
                   style=" font-weight: 700">
                {{ part.action }}
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-qty">
                {{ part.quantity }}
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                {{ part.cost | formatMoney }}
              </div>
              <div class="vehicle-block-table-body-item" style="width: 60px;">
                <label class="form-check-inline checkbox">
                  <input class="form-check-input" name="hide-series-checkbox" type="checkbox"
                         v-model="part.checkedReport"
                         :disabled="damage?.isDAEstimateCreated"
                         @change="(val)=>changeOnReport(val,part,area)"/>
                  <span class="icon" style="margin-left: 7.5px"><i class="bx bx-check"></i></span>
                </label>
              </div>
              <div class="vehicle-block-table-body-item" style="width: 60px;">
                <label class="form-check-inline checkbox">
                  <input class="form-check-input" name="hide-series-checkbox" type="checkbox"
                         v-model="part.checkedEst"
                         :disabled="damage?.isDAEstimateCreated"
                         @change="(val)=>changeCheckEst(val,part,area)"/>
                  <span class="icon" style="margin-left: 7.5px"><i class="bx bx-check"></i></span>
                </label>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="card-header bg-navyblue card-header-blue">Labour Assessment</div>
          <div v-for="(group,index) in Object.keys(damage.labour_assessment)" :key="index">
            <div class="card-header bg-navyblue">{{ group }}</div>
            <div class="vehicle-block-table">
              <div class="vehicle-block-table-header">
                <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-name">
                  Description
                </div>
                <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-hrs"
                     v-if="group === 'Paint'">
                  Paint
                </div>
                <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-hrs"
                     v-if="damage.AIEstimateType === 'quick-2' || damage.AIEstimateType === 'quick-5'">
                  Hrs
                </div>
                <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-cost"
                     v-if="damage.AIEstimateType === 'quick-2' || damage.AIEstimateType === 'quick-5'">
                  Rate
                </div>
                <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-cost">
                  Amount
                </div>
              </div>
              <div class="vehicle-block-table-body labour-assessment-block d-flex"
                   v-for="(part,index) in damage.labour_assessment[group]" :key="index">
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-name">
                  {{ part?.description }}
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-hrs"
                     v-if="group === 'Paint'">
                  {{ part?.paint_type }}
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-hrs"
                     v-if="damage.AIEstimateType === 'quick-2' || damage.AIEstimateType === 'quick-5'">
                  {{ part?.hours.toFixed(2) }}
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost"
                     v-if="damage.AIEstimateType === 'quick-2' || damage.AIEstimateType === 'quick-5'">
                  {{ part?.cost | formatMoney }}
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                  {{ part?.amount | formatMoney }}
                </div>
              </div>

              <div class="vehicle-block-table-body labour-assessment-block d-flex" style="margin-bottom: 30px">
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-name"
                     style="text-align: right">
                  Subtotals
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-hrs">
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-hrs"
                     v-if="damage.AIEstimateType === 'quick-2' || damage.AIEstimateType === 'quick-5'">
                  {{
                    damage.labour_assessment[group].reduce((a, b) => {
                      return a + b?.hours || 0
                    }, 0).toFixed(2)
                  }}
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost"
                     style="font-weight: 700">
                  {{
                    damage.labour_assessment[group].reduce((a, b) => {
                      return a + b.amount
                    }, 0) | formatMoney
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="margin-bottom: 30px">
          <div class="card-header bg-navyblue card-header-blue">Miscellaneous</div>
          <div class="card-header bg-navyblue">Others</div>
          <div class="vehicle-block-table">
            <div class="vehicle-block-table-header">
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-name">
                Description
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-hrs">
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-cost">
              </div>
              <div class="vehicle-block-table-header-item vehicle-block-table-parts-assessment-header-cost">
                Amount
              </div>
            </div>
            <div class="vehicle-block-table-body labour-assessment-block d-flex"
                 v-for="(item,index) in damage.miscellaneous_charges" :key="index">
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-name">
                {{ item?.description }}
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-hrs">
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                {{ item?.cost | formatMoney }}
              </div>
            </div>
            <div class="vehicle-block-table-body labour-assessment-block d-flex" style="margin-bottom: 30px">
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-name"
                   style="text-align: right">
                Subtotals
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-hrs">
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
              </div>
              <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost"
                   style="font-weight: 700; padding-right: 30px">
                {{
                  damage.miscellaneous_charges.reduce((a, b) => {
                    return a + b.cost
                  }, 0) | formatMoney
                }}
              </div>
            </div>
            <div style="display: flex;flex-direction: column; float: right;">
              <div class="vehicle-block-table-body amount labour-assessment-block d-flex">
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">Total
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                  {{ computedTotalAmount | formatMoney }}
                </div>
              </div>
              <div class="vehicle-block-table-body amount labour-assessment-block d-flex">
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">GST
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                  {{ Number(computedTotalAmount * 0.1) | formatMoney }}
                </div>
              </div>
              <div class="vehicle-block-table-body amount labour-assessment-block d-flex" style="margin-bottom: 30px">
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">Grand Total
                </div>
                <div class="vehicle-block-table-body-item vehicle-block-table-parts-assessment-body-cost">
                  {{ Number(computedTotalAmount * 1.1) | formatMoney }}
                </div>
              </div>
            </div>
          </div>
          <div style="height: 70px; margin-top: 50px">
            <div class="wizard__buttons col-lg-12 col-12" style="text-align: right;">
              <!-- <button class="btn btn-outline-primary button-save" style="margin-right: 20px">
                Save
              </button> -->
              <button :disabled="damage?.isDALimitReached" @click="$emit('rerun-assessment')"
                      class="btn btn-outline-primary button-rerun" style="margin-right: 20px">
                Rerun Assessment
              </button>
              <button :disabled="damage?.isDAEstimateCreated" @click="onCreateEstimate"
                      class="btn btn-primary button-create">
                <span :class="{ active: loadingCreateEstimate }">Create Estimate</span>
                <vue-simple-spinner v-if="loadingCreateEstimate" :size="23" class="advanced-search-spinner" style="margin-top: 9px;
                    margin-left: 85%;"></vue-simple-spinner>
              </button>
            </div>
          </div>
          <div class="vehicle-block-assessment-history">
            <div class="vehicle-block-assessment-history-title">Assessment History</div>
            <div class="vehicle-block-assessment-history-count">Run Count: {{ damage.history?.length }}</div>
            <div class="vehicle-block-assessment-history-items">
              <div class="vehicle-block-assessment-history-item d-flex" v-for="item in damage?.history"
                   :key="item.count">
                <div>{{ item.count }}.</div>
                <div style="margin-left: 10px">{{ item.createdAt }} - {{ item.userFullname }} -
                  {{ item.AIEstimateType }}
                </div>
              </div>
              <!-- <div class="vehicle-block-assessment-history-item d-flex">
                <div>2.</div>
                <div style="margin-left: 10px">22/10/2025 2:25am - Greg Tayler - Quick Estimate Hours</div>
              </div> -->
            </div>
            <div class="vehicle-block-assessment-history-error" v-if="damage?.isDALimitReached">
              <div style="text-transform: uppercase;">Assessment limit reached.</div>
              <div>The maximum amount of times an assessment can be run on this job has been reached.</div>
            </div>
          </div>
        </div>

        <!--        <div>
                  <div class="card-header bg-navyblue">Damage Analysis</div>
                  <div class="vehicle-block-table">
                    <div class="vehicle-block-table-header">
                      <div class="vehicle-block-table-header-item vehicle-block-table-header-description"
                           style="padding-left: 15px">Damage Area
                      </div>
                      <div class="vehicle-block-table-header-item vehicle-block-table-header-severity">Severity</div>
                      <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Description</div>
                      <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                    </div>
                    <div class="vehicle-block-table-body d-flex" v-for="(item, index) in damage?.assessment" :key="index">
                      <div class="vehicle-block-table-body-item vehicle-block-table-body-description">{{ item.area }}</div>
                      <div class="vehicle-block-table-body-item vehicle-block-table-body-severity">{{ item.severity }}</div>
                      <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">
                        {{ item.description }}
                      </div>
                      <template>
                        <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                          &lt;!&ndash;                    <div>
                                              <template v-for="(part,ind) in item.parts">
                                                {{getImageName(part.image_id)}}
                                              </template>
                                              </div>&ndash;&gt;
                          <div v-for="(part,ind) in item.parts" :key="ind">
                          <span
                              v-tooltip="{
                                       ...tooltipConfig,
                                       content: getTooltipContent(part.image_id)
                                        }"
                              @click="openImageGallery(part.image_id)"
                              class="image-link">
                            {{ getImageName(part.image_id) }}{{ item.parts.length - 1 == ind ? '' : ',' }}
                          </span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>-->
      </div>
      <div class="damaged-block">
        <div>
          <div class="analysis-title" style="margin-bottom: 5px">Damage Area Assessment</div>
          <div class="wizard__divider"></div>
          <div class="analysis-subtitle" style="margin-bottom: 5px">Areas of damaged are indicated below and is subject
            to further inspection.
          </div>
        </div>
        <div class="d-flex" style="position: relative;">
          <svg-parts-viewer :selectedSchemeParts="damage?.partsForSvg" :body="damage?.typeBody"/>
          <div v-if="false" class="damage-statistic-svg d-flex" style="position: absolute; right: 0; width: 200px">
            <div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Panels</div>
                <div class="damage-statistic-svg-info damage-statistic-svg-info-red">{{ areaForList.panels }}</div>
              </div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Interior</div>
                <div class="damage-statistic-svg-info">{{ areaForList.interior }}</div>
              </div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Wheels</div>
                <div class="damage-statistic-svg-info">{{ areaForList.wheel }}</div>
              </div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Tyres</div>
                <div class="damage-statistic-svg-info">{{ areaForList.tyres }}</div>
              </div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Electrical</div>
                <div class="damage-statistic-svg-info damage-statistic-svg-info-red">{{ areaForList.electrical }}</div>
              </div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Mechanical</div>
                <div class="damage-statistic-svg-info">{{ areaForList.mechanical }}</div>
              </div>
              <div class="d-flex">
                <div class="damage-statistic-svg-name">Overall Severity</div>
                <div class="damage-statistic-svg-info damage-statistic-svg-info-red">{{ areaForList.overallSeverity }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tabs-component tabs-component-2" style="position: static">
          <ul class="nav nav-tabs nav-tabs-2 float-sm-left">
            <li @click.prevent="selectCard('Photos')" class="tabs-component-tab nav-item">
              <a class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Photos'}">Photos</a>
            </li>
            <li @click.prevent="selectCard('Electrical')" class="tabs-component-tab nav-item">
              <a class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'Electrical'}">Electrical</a>
            </li>
            <li @click.prevent="selectCard('TyreRim')" class="tabs-component-tab nav-item">
              <a class="tabs-component-tab-a nav-link" :class="{'active': selectedCard == 'TyreRim'}">Tyre/Rim</a>
            </li>
            <li @click.prevent="selectCard('MechanicalSystem')" class="tabs-component-tab nav-item">
              <a class="tabs-component-tab-a nav-link"
                 :class="{'active': selectedCard == 'MechanicalSystem'}">Mechanical System</a>
            </li>
          </ul>
        </div>
        <div style="padding: 0 10px">
          <div v-if="selectedCard == 'Photos'">
            <div style=" min-height: 400px" :style="{maxHeight: heightPartsTable - 200 + 'px'}">
              <div v-for="(category,index) in damage?.categorys" :key="index"
                   :style="{height: vehicleTablesHeight[index] - 20 + 'px'}"
                   class="damaged-parts-tabs-photos-block"
              >
                <div class="damaged-parts-tabs-title">{{ category.area }}</div>
                <div class="damaged-parts-tabs-photos">
                  <div class="image-list-wrapper">
                    <div v-for="(img, index) in getFilteredImages(category.images)" :key="img.id"
                         class="image-list-image col-sm-3">
                      <div class="box bg-grey img-box">
                        <a @click="openImageGalleryFromPhotos(category.images, index)"
                           class="hand-pointer img-grid__link">
                          <img :src="img.previewW220 || img.src" class="img-fluid">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div v-if="selectedCard == 'Electrical'">
            <div v-if="damage?.electricalConcerns?.length">
              <div class="damaged-parts-tabs-title_table">Electrical Systems Check</div>
              <div class="vehicle-block-table">
                <div class="vehicle-block-table-header vehicle-block-table-header-damaged">
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-system_component">System
                    Component
                  </div>
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                </div>
                <div class="vehicle-block-table-body vehicle-block-table-body-damaged d-flex"
                     v-for="(item, index) in damage?.electricalConcerns" :key="index">
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-system_component">
                    {{ item?.system_component }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">
                    {{ item?.notes }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                    <span v-tooltip="{
                               ...tooltipConfig,
                               content: getTooltipContent(item?.image_id)
                                }" @click="openImageGallery(item?.image_id)" class="image-link">
                      {{ getImageName(item?.image_id) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="damaged-parts-tabs-title_table" style="padding: 30px 0">Additional Notes:</div>
              <div class="damaged-parts-tabs-subtitle_table">
                {{ damage?.electrical_systems_check_additional_notes?.additional_notes || '' }}
              </div>
            </div>

          </div>
          <div v-if="selectedCard == 'TyreRim'">
            <div v-if="damage?.tyreRimConcerns?.length">
              <div class="damaged-parts-tabs-title_table">Tyre and Rim Condition Check</div>
              <div class="vehicle-block-table">
                <div class="vehicle-block-table-header vehicle-block-table-header-damaged">
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-system_component">System
                    Component
                  </div>
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                </div>
                <div class="vehicle-block-table-body vehicle-block-table-body-damaged d-flex"
                     v-for="(item, index) in damage?.tyreRimConcerns" :key="index">
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-system_component">
                    {{ item?.system_component }}

                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">
                    {{ item?.notes }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                    <span v-tooltip="{
                            ...tooltipConfig,
                            content: getTooltipContent(item?.image_id)
                                 }" @click="openImageGallery(item?.image_id)" class="image-link">
                      {{ getImageName(item?.image_id) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="damaged-parts-tabs-title_table" style="padding: 30px 0">Additional Notes:</div>
              <div class="damaged-parts-tabs-subtitle_table">
                {{ damage?.tyre_rim_condition_check_additional_notes?.additional_notes || '' }}
              </div>
            </div>
          </div>
          <div v-if="selectedCard == 'MechanicalSystem'">
            <div v-if="damage?.mechanicalConcerns?.length">
              <div class="damaged-parts-tabs-title_table">Mechanical System Check</div>
              <div class="vehicle-block-table">
                <div class="vehicle-block-table-header vehicle-block-table-header-damaged">
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-system_component">System
                    Component
                  </div>
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-notes">Notes</div>
                  <div class="vehicle-block-table-header-item vehicle-block-table-header-image_id">Image ID</div>
                </div>
                <div class="vehicle-block-table-body vehicle-block-table-body-damaged d-flex"
                     v-for="(item, index) in damage?.mechanicalConcerns" :key="index">
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-system_component">
                    {{ item?.system_component }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-notes">
                    {{ item?.notes }}
                  </div>
                  <div class="vehicle-block-table-body-item vehicle-block-table-body-image_id">
                    <span v-tooltip="{
                                  ...tooltipConfig,
                                   content: getTooltipContent(item?.image_id)
                                 }" @click="openImageGallery(item?.image_id)" class="image-link">
                      {{ getImageName(item?.image_id) }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="damaged-parts-tabs-title_table" style="padding: 30px 0">Additional Notes:</div>
              <div class="damaged-parts-tabs-subtitle_table">
                {{ damage?.mechanical_condition_check_condition_check_additional_notes?.additional_notes || '' }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
    <image-gallery v-if="showGallery"
                   :images="galleryImages"
                   :current-index="galleryIndex"
                   :use-editor="false"
                   :show-remove="false"
                   :is-show-big-image="true"
                   :is-assessment="true"
                   @close-gallery="closeGallery"/>
  </div>
</template>
<script>
import _ from 'lodash'
import SvgPartsViewer from './../svg-parts-viewer.vue'
import ImageLightbox from '@/components/utility/image-lightbox/image-lightbox.vue'
import NumberFormatter from '@/components/utility/number-formatter.vue'
import ImageGallery from '@/components/utility/image-lightbox/image-gallery.vue'
import Spinner from 'vue-simple-spinner'
import Axios from 'axios'

export default {
  name: 'damage-assessment-ai',
  props: {
    images: [],
    rfqId: 0,
    rfqVehicle: {},
    damage: {
      type: Object,
      default: () => {}
    },
  },
  components: {
    ImageLightbox,
    SvgPartsViewer,
    NumberFormatter,
    ImageGallery,
    'vue-simple-spinner': Spinner,
  },
  data () {
    return {
      loadingCreateEstimate: false,
      parts: [],
      isLoading: false,
      valueLoader: 0,
      maxLoader: 100,
      timeRemaining: 0,
      progressInterval: null,
      timeInterval: null,
      damageParts: [],
      heightPartsTable: 0,
      selectedCard: 'Photos',
      imageCache: {},
      preloadedImages: {},
      showGallery: false,
      galleryImages: [],
      galleryIndex: 0,
      savedScrollPosition: 0,
      vehicleTablesHeight: [],
    }
  },
  computed: {
    computedTotalAmount () {
      let a = 0
      let da = this.damage?.assessment || []
      let prt_amount = da.flatMap((area, areaIndex) => {
        return area.parts.filter(part => part.checkedEst)
      }).reduce((a, b) => {
        if (b?.checkedReport === true) {
          return a + 0
        }
        return a + b.cost
      }, 0)
      a = a + (prt_amount || 0)
      let total_remove_and_replace_cost = this.damage?.labour_assessment['RR'].reduce((a, b) => {
        return a + b.amount
      },0)
      let total_repair_cost = this.damage?.labour_assessment['Repair'].reduce((a, b) => {
        return a + b.amount
      },0)
      let total_paint_cost = this.damage?.labour_assessment['Paint'].reduce((a, b) => {
        return a + b.amount
      },0)
      let total_miscellaneous_cost = this.damage?.miscellaneous_charges.reduce((a, b) => {
        return a + b.cost
      },0)
      a = a + (total_remove_and_replace_cost || 0)
      a = a + (total_repair_cost || 0)
      a = a + (total_paint_cost || 0)
      a = a + (total_miscellaneous_cost || 0)
      return a
    },
    partsForSvg () {
      if (_.isEmpty(this.damageParts)) return []
      return _.map(this.damageParts, 'area')
    },
    vehicle () {
      return this.damage?.vehicle || {}
    },
    areaForList () {
      return this.damage?.areaForList || {}
    },
    tooltipConfig () {
      return {
        html: true,
        placement: 'bottom',
        offset: 5,
        delay: { show: 200, hide: 100 },
        classes: 'tooltip-image',
        trigger: 'hover',
        autoHide: false,
        shown: () => this.updateTooltipPosition(),
        popperOptions: {
          modifiers: {
            preventOverflow: {
              enabled: true,
              boundariesElement: 'viewport'
            }
          }
        }
      }
    },
  },
  methods: {
    changeAllCheckEst (val, area) {
      const input = val.srcElement.checked
      const obg = this.damage.assessment.find((item) => {
        return item.area === area.area
      })
      obg.parts.forEach(part => {
        part.checkedEst = input
        if (!input) {
          part.checkedReport = input
        }
      })
    },
    changeOnReport (val, part, area) {
      if (val.srcElement.checked){
        part.checkedEst = val.srcElement.checked
        this.changeCheckEst(null, null, area)
      }
    },
    changeCheckEst (val = null, part = null, area) {
      if (!val?.srcElement?.checked && part) {
        part.checkedReport = val.srcElement.checked
      }
      area.allCheckedEst = area.parts.every(part => part.checkedEst)
    },
    async onCreateEstimate () {
      if (this.loadingCreateEstimate) return
      this.loadingCreateEstimate = true
      const parts = this.giveDamageParts(this.damage?.assessment)
      const res = await Axios.post(`/fe/estimate/${this.damage?.estimateId}/ai-damage/${this.damage?.aiQueueId}/create-estimate`, { parts })
      this.$emit('reload-estimate')
      this.loadingCreateEstimate = false
    },
    giveDamageParts (assessment) {
      if (!assessment) return []
      const result = assessment.flatMap((area, areaIndex) => {
        return area.parts.filter(part => part.checkedEst).map((part, partIndex) => {
          const reactivePart = {
            area: area.area,
            name: part.name,
            onReport: part.checkedReport,
          }
          return reactivePart
        })
      })
      return result
    },
    openImageGalleryFromPhotos (categoryImageIds, clickedIndex) {
      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop

      const ids = new Set((categoryImageIds || []).map(id => Number(id)))
      const filteredImages = (this.damage?.allImages || []).filter(img => ids.has(Number(img.id)))

      this.galleryImages = filteredImages.map(img => ({
        id: img.id,
        url: img.src
      }))

      this.galleryIndex = clickedIndex
      this.showGallery = true
    },
    updateTooltipPosition () {
      // Simply trigger a window resize event which forces popper to recalculate
      this.$nextTick(() => {
        setTimeout(() => {
          window.dispatchEvent(new Event('resize'))
        }, 100)
      })
    },
    selectCard: function (card) {
      console.log(card)
      this.selectedCard = card
    },
    formatNotes (notes) {
      return notes.replace(/\n/g, '<br>')
    },
    getPreview (id) {
      // Check cache first for instant return
      if (this.imageCache[id]) {
        return this.imageCache[id]
      }

      // Original logic to find image
      const imageUrl = this.damage?.allImages.find((item) => {
        return Number(item.id) === Number(id)
      })?.previewW220

      // Store in cache for future use
      if (imageUrl) {
        this.imageCache[id] = imageUrl
      }

      return imageUrl
    },
    getImageName (imageId) {
      const image = this.images.find(img => Number(img.id) === Number(imageId))
      return image ? image.name : ''
    },
    getFilteredImages (categoryImages) {
      const ids = new Set((categoryImages || []).map(id => Number(id)))
      const list = (this.damage?.allImages || []).filter(img => ids.has(Number(img.id)))
      return list
    },

    preloadAllTooltipImages () {
      const imageIds = new Set()

      // Collect image IDs from Damage Assessment section
      if (this.damage?.assessment) {
        this.damage.assessment.forEach(item => {
          if (item.parts && Array.isArray(item.parts)) {
            item.parts.forEach(part => {
              if (part.image_id) {
                imageIds.add(part.image_id)
              }
            })
          }
        })
      }

      // Collect image IDs from Electrical Concerns
      if (this.damage?.electricalConcerns && Array.isArray(this.damage.electricalConcerns)) {
        this.damage.electricalConcerns.forEach(item => {
          if (item.image_id) {
            imageIds.add(item.image_id)
          }
        })
      }

      // Collect image IDs from Tyre/Rim Concerns
      if (this.damage?.tyreRimConcerns && Array.isArray(this.damage.tyreRimConcerns)) {
        this.damage.tyreRimConcerns.forEach(item => {
          if (item.image_id) {
            imageIds.add(item.image_id)
          }
        })
      }

      // Collect image IDs from Mechanical Concerns
      if (this.damage?.mechanicalConcerns && Array.isArray(this.damage.mechanicalConcerns)) {
        this.damage.mechanicalConcerns.forEach(item => {
          if (item.image_id) {
            imageIds.add(item.image_id)
          }
        })
      }

      // Preload each unique image
      imageIds.forEach(imageId => {
        const imageUrl = this.getPreview(imageId)
        if (imageUrl && !this.preloadedImages[imageId]) {
          const img = new Image()
          img.src = imageUrl
          img.onload = () => {
            this.preloadedImages[imageId] = true
            //   console.log(`Preloaded image: ${imageId}`)
          }
          img.onerror = () => {
            console.warn(`Failed to preload image: ${imageId}`)
          }
        }
      })

      // console.log(`Preloading ${imageIds.size} tooltip images...`)
    },
    getTooltipContent (imageId) {
      const imageUrl = this.getPreview(imageId)
      if (!imageUrl) return ''

      // Create image with load handler that triggers position update
      const img = new Image()
      img.onload = () => {
        this.$nextTick(() => {
          // Dispatch custom event to update tooltip position
          window.dispatchEvent(new Event('resize'))
        })
      }
      img.src = imageUrl

      return `<img src="${imageUrl}" style="max-width: 188px; object-fit: contain; display: block;" />`
    },
    openImageGallery (imageId) {
      this.savedScrollPosition = window.pageYOffset || document.documentElement.scrollTop

      const allImages = this.damage?.allImages || []
      const imageIndex = allImages.findIndex(img => Number(img.id) === Number(imageId))

      if (imageIndex === -1) return

      this.galleryImages = allImages.map(img => ({
        id: img.id,
        url: img.src
      }))

      this.galleryIndex = imageIndex
      this.showGallery = true
    },

    closeGallery () {
      this.showGallery = false
      this.$nextTick(() => {
        window.scrollTo(0, this.savedScrollPosition)
      })
    },
  },
  created () {
  },
  mounted () {
    // Preload all tooltip images when component mounts
    const blocks = this.$refs.vehicleTable;
    blocks.forEach(block => {
      const height = block.offsetHeight;
      this.vehicleTablesHeight.push(height)
    });
    this.$nextTick(() => {
      this.preloadAllTooltipImages()
    })
  },
  watch: {
    'damage': {
      handler (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.$nextTick(() => {
            // Clear caches and reload
            this.imageCache = {}
            this.preloadedImages = {}
            this.preloadAllTooltipImages()
          })
        }
      },
      deep: true
    }
  },
}
</script>
<style scoped>
.button-save:hover,
.button-save:focus,
.button-save:active:focus {
  background-color: #f5f8ff;
  color: #5E79FF;
}

.button-save[disabled],
.button-save[disabled]:hover,
.button-save[disabled]:focus,
.button-save[disabled]:active:focus {
  background-color: #d7d7d7;
}

.button-rerun {
  border-color: #ec731c;
  color: #ec731c;
}

.button-rerun:hover,
.button-rerun:focus,
.button-rerun:active:focus {
  border-color: #ec731c;
  background-color: #ffeee2;
  color: #ec731c;
}

.button-rerun[disabled],
.button-rerun[disabled]:hover,
.button-rerun[disabled]:focus,
.button-rerun[disabled]:active:focus {
  border-color: #ec731c;
  background-color: #d7d7d7;
  color: #ec731c;
}

.button-create {
  position: relative;
}

.button-create:hover {
  background-color: #6781ff;
}

.button-create .active {
  margin-right: 30px;
}

.button-create[disabled],
.button-create[disabled]:hover,
.button-create[disabled]:focus,
.button-create[disabled]:active:focus {
  background-color: #5E79FF;
}

.vehicle-block-assessment-history {
  border: 2px solid rgba(27, 30, 56, 0.25);
  border-radius: 5px;
  padding: 10px;
}

.vehicle-block-assessment-history-title,
.vehicle-block-assessment-history-count {
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 5px;
}

.vehicle-block-assessment-history-item {
  font-weight: 700;
  color: #343434;
}

.vehicle-block-assessment-history-error {
  color: #be0000;
  font-weight: 700;
  margin-top: 10px;
  font-size: 13px;
  line-height: 17px;
}

.card-header-blue {
  background-color: #5d78fd !important;
  color: white !important;
}

.vehicle-block-summary-item {
  border: 2px solid #00786a;
  border-radius: 4px;
  padding: 10px 15px;
  color: #01796b;
  margin: 5px;
  width: 250px;
  overflow: auto;
}

.vehicle-block-summary-item-total-title {
  text-align: center;
  font-size: 18px;
  margin-bottom: 10px;
  font-weight: 700;
  text-transform: uppercase;
}

.vehicle-block-summary-item-total-sum {
  text-align: center;
  font-size: 20px;
  font-weight: 800;
}

.vehicle-block-summary-item-category-name {
  font-weight: 900;
  width: 30%;
}

.vehicle-block-summary-item-category-sum {
  font-weight: 600;
}

.vehicle-block-summary-notes {
  border: 2px solid rgba(27, 30, 56, 0.25);
  padding: 10px 15px;
  margin-bottom: 5px;
}

body.gallery-open {
  overflow: hidden;
  position: fixed;
  width: 100%;
}

/* Custom tooltip styling */
.image-link-wrapper {
  position: relative;
  display: inline-block;
  vertical-align: baseline;
}

.image-link-with-tooltip {
  position: relative;
  color: rgb(0, 123, 255);
  display: inline-block;
}

.image-link-with-tooltip:hover {
  color: #0056b3;
}

.custom-tooltip {
  visibility: hidden;
  opacity: 0;
  position: fixed;
  z-index: 99999;
  background-color: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  padding: 4px;
  transition: opacity 0.2s ease-in-out;
  pointer-events: none;
  width: max-content;
  max-width: 200px;
  transform: translateY(5px);
}

.custom-tooltip::before {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 20px;
  border: 6px solid transparent;
  border-bottom-color: #ddd;
}

.custom-tooltip::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: 21px;
  border: 5px solid transparent;
  border-bottom-color: white;
}

.image-link-with-tooltip:hover .custom-tooltip {
  visibility: visible;
  opacity: 1;
}

.custom-tooltip img {
  display: block;
  max-width: 100%;
  height: auto;
}

.tabs-component .tabs-component-tab-a {
  cursor: pointer;
  user-select: none;
}

.damage-statistic-svg-name {
  width: 70%;
  margin-bottom: 3px;
}

.damage-statistic-svg-info {
  width: 30%;
}

.damage-statistic-svg-info-red {
  color: red;
}

.vehicle-details-block {
  overflow-x: auto;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
  margin-bottom: 5px;
}

.vehicle-details-block-row,
.vehicle-details-block-row-plus {
  min-height: 30px;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
  color: #212529;
  font-size: 13px !important;
  line-height: 16px !important;
  letter-spacing: normal;
  font-weight: 500 !important;
  font-family: "Inter", sans-serif;
  min-width: 850px;
  padding: .5rem;
}

.vehicle-details-block-row-plus:last-child {
  border-bottom: 0;
}

.vehicle-details-block-row-plus {
  min-width: auto;
}

.vehicle-details-block-row-left_left {
  width: 45%;
}

.vehicle-details-block-row-left_right {
  width: 55%;
}

.vehicle-details-block-row-left {
  width: 70%;
}

.vehicle-details-block-row-plus .vehicle-details-block-row-left {
  width: 100%;
}

.vehicle-details-block-row-plus .vehicle-details-block-row-left_right {
  margin-left: 5px;
}

.vehicle-details-block-row-right {
  width: 30%;
}

.vehicle-details-block-row-name {
  font-weight: 600;
  width: 100px;
}

.vehicle-details-block-left-info {
  border: 1px solid rgba(27, 30, 56, 0.25);
  width: 30%;
  /* margin: 5px 0;*/
  padding: 10px 15px;
  border-radius: 4px;
  max-height: 150px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.vehicle-block {
  width: 65%;
}

.damaged-block {
  width: 35%;
  min-width: 350px;
  margin-left: 20px;
}

.analysis-title {
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
  color: #1C1F39;
  width: 50%;
}

.analysis-subtitle {
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
  margin-top: 10px;
}

.analysis-btns {
  position: relative;
  bottom: 10px;
}

.vehicle-block-info {
  font-size: 13px;
  font-weight: 600;
  margin-top: 10px;
}

.vehicle-block-info span {
  margin-left: 12px;
}

.vehicle-block-info-item {
  width: 33.333%;
}

.vehicle-block-table {
  overflow-y: hidden;
  overflow-x: auto;
}

.damage-form-table-header-item-on-report-icon {
  color: white;
  background-color: #d09400;
  font-weight: bold;
  height: 20px;
  width: 20px;
  border-radius: 999px;
  font-size: 14px;
  padding: 3px;
  line-height: 16px;
  margin-top: 5px;
  margin-left: 10px;
}

.vehicle-block-table-header {
  width: 100%;
  background-color: rgba(27, 30, 56, .1) !important;
  color: #1c1f39 !important;
  font-size: 13px;
  font-weight: 700;
  line-height: 18px;
  display: flex;
  align-items: center;
  min-width: 850px;
}

.vehicle-block-table-body {
  min-height: 47px;
  border-bottom: 1px solid rgba(27, 30, 56, 0.25);
  color: #212529;
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: normal;
  font-weight: 500 !important;
  font-family: "Inter", sans-serif;
  min-width: 850px;
}

.vehicle-block-table-body:hover {
  background-color: #e5f6f5 !important;
}

.vehicle-block-table-body.amount {
  min-width: 0;
  float: right;
}

.vehicle-block-table-body.amount .vehicle-block-table-body-item {
  display: flex;
  font-weight: 600;
}

.vehicle-block-table-header-item,
.vehicle-block-table-body-item {
  padding: .75rem;
}

.vehicle-block-table-parts-assessment-body-status {
  text-transform: uppercase;
  color: white;
  border-radius: 3px;
  text-align: center;
  font-weight: bold;
}

.vehicle-block-table-parts-assessment-body-status div {
  padding: 7px;
}

.vehicle-block-table-parts-assessment-body-status .confirmed-status {
  background-color: #00af4f;
}

.vehicle-block-table-parts-assessment-body-status .provisional-status {
  background-color: #eb7c31;
}

.vehicle-block-table-parts-assessment-header-status,
.vehicle-block-table-parts-assessment-body-status,
.vehicle-block-table-parts-assessment-header-cost,
.vehicle-block-table-parts-assessment-body-cost {
  min-width: 120px;
  max-width: 120px;
}

.vehicle-block-table-parts-assessment-header-name,
.vehicle-block-table-parts-assessment-body-name {
  flex-grow: 1;
  min-width: 200px;
  width: 100%;
}

.vehicle-block-table-parts-assessment-header-action,
.vehicle-block-table-parts-assessment-body-action {
  min-width: 80px;
  max-width: 80px;
}

.vehicle-block-table-parts-assessment-header-qty,
.vehicle-block-table-parts-assessment-body-qty {
  width: 40px;
  min-width: 40px;
  text-align: center;
}

.labour-assessment-block {
  min-height: 29px;
}

.labour-assessment-block .vehicle-block-table-body-item {
  padding: .5rem;
}

.vehicle-block-table-parts-assessment-header-hrs,
.vehicle-block-table-parts-assessment-body-hrs {
  width: 60px;
  min-width: 60px;
  text-align: center;
}

.vehicle-block-table-header-description,
.vehicle-block-table-header-notes,
.vehicle-block-table-body-description,
.vehicle-block-table-body-notes {
  flex-grow: 1;
  min-width: 200px;
  width: 100%;
}

.vehicle-block-table-body-description {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  font-weight: 700;
}

.vehicle-block-table-header-qty,
.vehicle-block-table-body-qty {
  width: 40px;
  min-width: 40px;
  text-align: center;
}

.vehicle-block-table-header-quote_all,
.vehicle-block-table-body-quote_all {
  width: 70px;
}

.vehicle-block-table-header-condition,
.vehicle-block-table-body-condition {
  min-width: 80px;
}

.vehicle-block-table-header-action,
.vehicle-block-table-body-action {
  min-width: 65px;
}

.vehicle-block-table-header-severity,
.vehicle-block-table-header-image_id,
.vehicle-block-table-body-severity,
.vehicle-block-table-body-image_id {
  display: flex;
  flex-direction: column;
  min-width: 150px;
  max-width: 150px;
}

.vehicle-block-table-body-image_id {
  color: rgb(0, 123, 255);
  overflow-wrap: break-word;
}

.vehicle-block-table-body-image_id:hover {
  color: #0056b3 !important;
}

label.checkbox > input[type="checkbox"] + span.icon i {
  background-color: #5d78fd;
  height: 23px;
  width: 23px;
  border-radius: 3px;
}

.bx-check:before {
  color: white;
}

.damaged-parts-tabs-title,
.damaged-parts-tabs-title_table {
  font-size: 13px;
  font-weight: 600;
  line-height: 24px;
}

.damaged-parts-tabs-title_table {
  font-size: 15px;
  padding: 10px 0;
}

.damaged-parts-tabs-photos {
  width: 100%;
  border: 2px solid rgba(27, 30, 56, 0.25);
  border-radius: 3px;
  flex-wrap: wrap;
  padding-top: 10px;
}

.damaged-parts-tabs-photos >>> img {
  width: 100%;
  object-fit: cover;
  height: 120px;
}

.damaged-parts-tabs-photos >>> .image-list-wrapper {
  width: 100%;
  object-fit: cover;
  flex-wrap: wrap;
  display: flex;

}

.damaged-parts-tabs-photos-block:last-child {
  margin-bottom: 30px;
}

.damaged-parts-tabs-photos >>> .image-list-image {
  width: 33.333%;
}

.damaged-parts-tabs-photos >>> .image-list-image .delete {
  display: none;
}

.damaged-parts-tabs-photos-item {
  width: 33.333%;
  padding: 3px;
}

.damaged-parts-tabs-photos-item-photo img {
  object-fit: cover;
  width: 100%;
}

.damaged-parts-tabs-photos-item-name {
  text-align: center;
  padding: 15px 0;
  color: rgb(0, 123, 255) !important;
}

.damaged-parts-tabs-photos-block {
  margin-top: 20px;
}

.electrical-concerns {
  padding: 20px;
}

.no-concerns {
  text-align: center;
  padding: 20px;
  font-size: 16px;
  font-weight: 600;
  color: #666;
}

.concern-item {
  margin-bottom: 20px;
  padding: 20px;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

.concern-title {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 10px;
}

.concern-reason {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.concern-notes {
  font-size: 14px;
  color: #666;
}

.vehicle-block-table-header-system_component,
.vehicle-block-table-body-system_component {
  min-width: 100px;
}

.vehicle-block-table-body-system_component {
  font-weight: 700;
}

.vehicle-block-table-body-damaged {
  padding: 20px 0;
}

.vehicle-block-table-header-damaged,
.vehicle-block-table-body-damaged {
  min-width: 420px;
}

.damaged-parts-tabs-subtitle_table {
  font-size: 12px !important;
  line-height: 16px !important;
  letter-spacing: normal;
  font-weight: 500 !important;
}

.vehicle-block-table-body-damaged .vehicle-block-table-body-system_component,
.vehicle-block-table-body-damaged .vehicle-block-table-body-image_id {
  align-self: center;
}

.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  backdrop-filter: blur(2px);
}

.loading-content {
  background: white;
  padding: 30px 40px;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  text-align: center;
  max-width: 450px;
  width: 90%;
  border: 1px solid #e9ecef;
}

.loading-spinner {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.ai-icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  animation: pulse 2s infinite;
}

.ai-loader-icon {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.1);
    opacity: 0.8;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.progress-container {
  width: 100%;
  margin-top: 10px;
}

.progress-bar {
  height: 8px;
  background-color: #e9ecef;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 8px;
  position: relative;
}

.progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #29BBC1, #1a9ea3);
  transition: width 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}

.progress-bar-fill::after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
      90deg,
      transparent,
      rgba(255, 255, 255, 0.4),
      transparent
  );
  animation: shimmer 2s infinite;
}

.progress-percentage {
  font-size: 13px;
  color: #6c757d;
  text-align: right;
  font-weight: 500;
}

@keyframes shimmer {
  0% {
    transform: translateX(-100%);
  }
  100% {
    transform: translateX(100%);
  }
}

/* v-tooltip Styling */
.image-link {
  color: rgb(0, 123, 255);
  cursor: pointer;
  display: inline-block;
  transition: color 0.2s ease;
  padding: 4px 2px;
}

.image-link:hover {
  color: #0056b3;
  text-decoration: underline;
}

</style>
<style>
.tooltip.tooltip-image {
  display: block !important;
  z-index: 99999 !important;
  font-family: inherit;
  width: auto !important; /* Override global 200px width */
  background-color: transparent !important; /* Override global white background */
  border: none !important; /* Override global blue border */
  position: absolute !important; /* Ensure proper positioning */
  pointer-events: none !important;
}

.tooltip.tooltip-image .tooltip-inner {
  background: white;
  color: black;
  border-radius: 4px;
  padding: 4px !important;
  border: none !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  max-width: none !important;
  width: auto !important;
  line-height: 0;
  pointer-events: auto !important;
}

.tooltip.tooltip-image .tooltip-arrow {
  width: 0;
  height: 0;
  border-style: solid;
  position: absolute;
  margin: 5px;
  border-color: white;
  z-index: 1;
  display: none;
}


.tooltip.tooltip-image[x-placement^="top"] {
  margin-bottom: 5px;
}

/*
.tooltip.tooltip-image[x-placement^="top"] .tooltip-arrow {
  border-width: 6px 6px 0 6px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  bottom: -6px;
  left: calc(50% - 6px);
  margin-top: 0;
  margin-bottom: 0;
}
*/


.tooltip.tooltip-image[x-placement^="bottom"] {
  margin-top: 5px;
}

/*
.tooltip.tooltip-image[x-placement^="bottom"] .tooltip-arrow {
  border-width: 0 6px 6px 6px;
  border-left-color: transparent !important;
  border-right-color: transparent !important;
  border-top-color: transparent !important;
  top: -6px;
  left: calc(50% - 6px);
  margin-top: 0;
  margin-bottom: 0;
}
*/

.tooltip.tooltip-image[x-placement^="right"] {
  margin-left: 5px;
}

/*
.tooltip.tooltip-image[x-placement^="right"] .tooltip-arrow {
  border-width: 6px 6px 6px 0;
  border-left-color: transparent !important;
  border-top-color: transparent !important;
  border-bottom-color: transparent !important;
  left: -6px;
  top: calc(50% - 6px);
  margin-left: 0;
  margin-right: 0;
}
*/
.tooltip.tooltip-image[x-placement^="left"] {
  margin-right: 5px;
}

/*
.tooltip.tooltip-image[x-placement^="left"] .tooltip-arrow {
  border-width: 6px 0 6px 6px;
  border-top-color: transparent !important;
  border-right-color: transparent !important;
  border-bottom-color: transparent !important;
  right: -6px;
  top: calc(50% - 6px);
  margin-left: 0;
  margin-right: 0;
}
*/
.tooltip.tooltip-image[aria-hidden='true'] {
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.15s, visibility 0.15s;
}

.tooltip.tooltip-image[aria-hidden='false'] {
  visibility: visible;
  opacity: 1;
  transition: opacity 0.15s;
}

/* Ensure images in tooltip display correctly */
.tooltip.tooltip-image .tooltip-inner img {
  display: block;
  max-width: 188px;
  width: auto;
  height: auto;
  border: none !important;
  outline: none !important;
  border-radius: 2px;
  margin: 0;
  padding: 0;
  vertical-align: top;
}
</style>
